// REACT & REACT HOOKS
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

// STORE ACTIONS
import { getAllSubscriptions } from "store/actions";

// COMPONENTS
import ControlArea from "components/Layout/control-area";
import BootyPagination from "components/shared/pagination";
import TableControl from "components/shared/table";

// ASSETS
import Icon from "./assets/subscriptions.svg";

// CONFIG
import { REACT_APP_STORES_URL } from "config";

// HELPERS
import { handleErrMsg } from "helpers/functions";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

// STYLES
import styles from "./styles/style.module.scss";

const Subscriptions = () => {
    const { subscriptions, loading, error } = useSelector(
        (state) => state.subscriptions
    );
    const { applicationId } = useParams();
    const dispatch = useDispatch();
    const { formatMessage, locale } = useIntl();
    const [isDispatched, setIsDispatched] = useState(false);

    useEffect(() => {
        setIsDispatched(true);
        dispatch(getAllSubscriptions({ applicationId }));
    }, [dispatch, applicationId]);

    // error
    useEffect(() => {
        if (error && isDispatched) {
            toastErrorMessage(
                formatMessage({ id: handleErrMsg(error) }),
                locale
            );
        }
    }, [error, formatMessage, locale, isDispatched]);

    const columns = [
        {
            name: <FormattedMessage id="appName" />,
            selector: (row) => row?.appName?.[locale] || row?.appName,
            sortable: true,
        },
        {
            name: <FormattedMessage id="store" />,
            selector: (row) => row?.storeId?.name?.[locale],
            sortable: true,
        },
        {
            name: <FormattedMessage id="storeUrl" />,
            selector: (row) => (
                <a
                    rel="noreferrer"
                    href={`${REACT_APP_STORES_URL}${row?.storeId?.slug}`}
                    target="_blank"
                >
                    {row?.storeId?.slug}
                </a>
            ),
            sortable: true,
        },
    ];
    return (
        <div className={styles["subscriptions"]}>
            <ControlArea
                btnTxt={false}
                cardTxt={<FormattedMessage id={"subscriptions"} />}
                icon={Icon}
                url="/subscriptions/add"
            />
            <TableControl
                title={"subscriptionsTableShow"}
                columns={columns}
                data={subscriptions}
                loading={loading}
            />
            <BootyPagination metaData={subscriptions?.metadata} />
        </div>
    );
};

export default Subscriptions;
